import axios from 'axios';

// Function to create a configured axios instance
export const createApiClient = (language) => {
  const baseUrl = process.env.REACT_APP_API_URL || 'https://baleeg-backend.95.217.57.161.sslip.io/';
  // Add '/ar/' to the baseURL if language is Arabic
  const adjustedBaseUrl = language === 'ar' ? `${baseUrl}${baseUrl.endsWith('/') ? 'ar/' : '/ar/'}` : baseUrl;
  
  const apiClient = axios.create({
    baseURL: adjustedBaseUrl,
    timeout: 300000,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  });

  // Request interceptor - modify requests before they're sent
  apiClient.interceptors.request.use(
    (config) => {
      // Get token from localStorage
      const token = localStorage.getItem('authToken');
      
      // If token exists, add it to request headers
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor - handle responses before they're returned to your code
  apiClient.interceptors.response.use(
    (response) => {
      // Return successful responses directly
      return response;
    },
    (error) => {
      // Handle errors globally
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        
        // Handle 401 Unauthorized (token expired)
        if (error.response.status === 401) {
          // Clear authentication data
          localStorage.removeItem('authToken');
          // Redirect to login or dispatch an action depending on your setup
        }
        
        // Handle other error statuses as needed
      } else if (error.request) {
        // The request was made but no response was received
        console.error('Network error, no response received');
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error in request setup:', error.message);
      }
      
      return Promise.reject(error);
    }
  );

  return apiClient;
};

// Get the current language from localStorage or use 'en' as default
const getCurrentLanguage = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('language') || 'en';
  }
  return 'en';
};

// Custom hook to get an API client with the current language
export const useApiClient = () => {
  // Get the current language directly from localStorage instead of context
  const language = getCurrentLanguage();
  return createApiClient(language);
};

// Default export with default language (for backwards compatibility)
export default createApiClient(getCurrentLanguage()); 